// Couleurs statuts
export const STATUS_COLORS = {
  'En cours': '#3B82F6',
  'Plan validé par Client': '#6366F1',
  'Déposé': '#F59E0B',
  'Défavorable': '#EF4444',
  'Favorable': '#10B981',
  'Autorisé': '#8B5CF6',
  'Chantier démarré': '#F97316',
  'Fin Travaux': '#06B6D4'
};

// Ordre progression statuts (workflow)
// En cours -> Plan validé par Client -> Déposé -> Défavorable OR Favorable
// If Défavorable -> back to Déposé
// If Favorable -> Autorisé -> Chantier démarré -> Fin Travaux
export const STATUS_ORDER = [
  'En cours',
  'Plan validé par Client',
  'Déposé',
  'Défavorable',
  'Favorable',
  'Autorisé',
  'Chantier démarré',
  'Fin Travaux'
];

// Statuts suivants possibles selon le statut actuel
export const STATUS_TRANSITIONS = {
  'En cours': ['Plan validé par Client'],
  'Plan validé par Client': ['Déposé'],
  'Déposé': ['Défavorable', 'Favorable'],
  'Défavorable': ['Déposé'],
  'Favorable': ['Autorisé'],
  'Autorisé': ['Chantier démarré'],
  'Chantier démarré': ['Fin Travaux'],
  'Fin Travaux': []
};

// 4 Zones Merchich
export const ZONES_MERCHICH = [
  {
    id: 'EPSG:26191',
    name: 'Zone 1 - Nord Maroc',
    shortName: 'Nord',
    description: 'Casablanca, Rabat, Tanger, Fès, Meknès',
    bounds: { xMin: 100000, xMax: 700000, yMin: 100000, yMax: 600000 }
  },
  {
    id: 'EPSG:26192',
    name: 'Zone 2 - Sud Maroc',
    shortName: 'Sud',
    description: 'Marrakech, Agadir, Essaouira, Safi',
    bounds: { xMin: 100000, xMax: 700000, yMin: 100000, yMax: 600000 }
  },
  {
    id: 'EPSG:26194',
    name: 'Zone 3 - Sahara Nord',
    shortName: 'Sahara N',
    description: 'Laâyoune, Guelmim, Tan-Tan',
    bounds: { xMin: 800000, xMax: 1600000, yMin: 100000, yMax: 700000 }
  },
  {
    id: 'EPSG:26195',
    name: 'Zone 4 - Sahara Sud',
    shortName: 'Sahara S',
    description: 'Dakhla, Aousserd',
    bounds: { xMin: 1100000, xMax: 1900000, yMin: 100000, yMax: 700000 }
  }
];

// Proj4 definitions (4 zones uniquement)
export const PROJ4_DEFINITIONS = {
  "EPSG:26191": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=31,146,47,0,0,0,0 +units=m +no_defs +type=crs",
  "EPSG:26192": "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.999615596 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=31,146,47,0,0,0,0 +units=m +no_defs +type=crs",
  "EPSG:26194": "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.999616304 +x_0=1200000 +y_0=400000 +ellps=clrk80ign +towgs84=31,146,47,0,0,0,0 +units=m +no_defs +type=crs",
  "EPSG:26195": "+proj=lcc +lat_1=22.5 +lat_0=22.5 +lon_0=-5.4 +k_0=0.999616437 +x_0=1500000 +y_0=400000 +ellps=clrk80ign +towgs84=31,146,47,0,0,0,0 +units=m +no_defs +type=crs"
};

// Villes par zone
export const CITIES_BY_ZONE = {
  'EPSG:26191': ['Casablanca', 'Rabat', 'Tanger', 'Fès', 'Meknès', 'Tétouan', 'Oujda', 'Kenitra', 'Salé'],
  'EPSG:26192': ['Marrakech', 'Agadir', 'Essaouira', 'Safi', 'Beni Mellal', 'Ouarzazate', 'El Jadida'],
  'EPSG:26194': ['Laâyoune', 'Guelmim', 'Tan-Tan', 'Assa'],
  'EPSG:26195': ['Dakhla', 'Aousserd']
};

// Régimes fonciers (Titre et Réquisition en premier)
export const REGIMES_FONCIERS = [
  'Titre',
  'Réquisition',
  'Melk',
  'Habous',
  'Guich',
  'Collectif',
  'Domanial'
];

// Régimes nécessitant une référence
export const REGIMES_WITH_REFERENCE = ['Titre', 'Réquisition'];

// Natures de projets
export const NATURES_PROJETS = [
  'Immeuble R+2',
  'Immeuble R+3',
  'Immeuble R+4',
  'Villa',
  'Appartement',
  'Commerce',
  'Bureau',
  'Industrie',
  'Lotissement',
  'Équipement public'
];

// Messages d'erreur
export const ERROR_MESSAGES = {
  FIREBASE_CONNECTION: 'Erreur connexion Firebase',
  INVALID_CREDENTIALS: 'Identifiants incorrects',
  PROJECT_NOT_FOUND: 'Projet introuvable',
  COORDINATE_INVALID: 'Coordonnées invalides',
  ZONE_MISMATCH: 'Coordonnées hors zone',
  REQUIRED_FIELD: 'Ce champ est requis',
  INVALID_EMAIL: 'Format d\'email invalide',
  PASSWORD_MISMATCH: 'Les mots de passe ne correspondent pas',
  PASSWORD_TOO_SHORT: 'Le mot de passe doit contenir au moins 6 caractères'
};

// Config par défaut
export const DEFAULT_CONFIG = {
  MAP_CENTER: { lat: 33.9716, lng: -6.8498 },
  MAP_ZOOM: 6,
  MAX_SEARCH_SUGGESTIONS: 5,
  DEBOUNCE_DELAY: 300,
  ITEMS_PER_PAGE: 50
};

// Rôles utilisateurs
export const ROLES = {
  ARCHITECT: 'architect',
  SECRETAIRE: 'secretaire',
  TECHNICIEN: 'technicien'
};

export const ROLE_LABELS = {
  architect: 'Architecte',
  secretaire: 'Secrétaire',
  technicien: 'Technicien'
};

// Rôles ayant accès à la comptabilité et à toute la gestion du cabinet
export const FULL_ACCESS_ROLES = [ROLES.ARCHITECT, ROLES.SECRETAIRE];
